import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {...state}
}

export function fulfilled(state, payload, result) {
  return {
    ...state,
    allAzubis: result,
  }
}
fulfilled.chain = (state, payload, result) =>
  payload.loadGetAzubisWithAbteilungen
    ? actions.filter.getAzubisWithAbteilungen({azubiIds: result.map(u => u.id)})
    : () => {}

export function rejected(state) {
  return state
}

export async function action() {
  try {
    return await Api.getAzubisAsAusbilder()
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
